import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  insuranceQuotation: {},
  quotationReceived: false,
  isLoading: false,
  error: "",
  hasData: false,
  selectedInsurance: 0
};
const insuranceQuotationSlice = createSlice({
  name: "insuranceQuotation",
  initialState,
  reducers: {
    getQuotationRequest: state => {
      state.isLoading = true;
    },
    quotationRequestSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.insuranceQuotation = action.payload;
    },
    quotationRequestFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
    },
    setAlreadyQuotation: (state, action) => {
      state.quotationReceived = action.payload;
    },
    setInsuranceSelected: (state, action) => {
      state.selectedInsurance = action.payload;
    },
    resetQuotation: state => {
      state.insuranceQuotation = {};
      state.isLoading = false;
      state.error = "";
      state.hasData = false;
    },
    resetQuotationStatus: state => {
      state.quotationReceived = false;
    },
    resetSelectedInsurance: state => {
      state.selectedInsurance = 0;
    }
  }
});
export const {
  getQuotationRequest,
  quotationRequestSuccess,
  quotationRequestFailure,
  resetQuotation,
  resetQuotationStatus,
  setAlreadyQuotation,
  setInsuranceSelected,
  resetSelectedInsurance
} = insuranceQuotationSlice.actions;
export default insuranceQuotationSlice.reducer;